import { ComponentProps, SyntheticEvent } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';

type BaseProps = ComponentProps<typeof BottomSheet>;

type BlockingBottomSheetProps = Omit<BaseProps, 'blocking' | 'sibling'>;

/**
 * Custom component that works around iOS backdrop blocking issues.
 * "Interactive elements beneath overlay are not "blocked" in iOS"
 * https://github.com/stipsan/react-spring-bottom-sheet/issues/180
 */
export const BlockingBottomSheet = (
  props: BlockingBottomSheetProps,
): JSX.Element => {
  const { children, onDismiss, ...rest } = props;

  const swallowEvent = (e: SyntheticEvent): void => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <BottomSheet
      {...rest}
      onDismiss={onDismiss}
      blocking={false}
      sibling={
        <div
          data-rsbs-backdrop="true"
          role="button"
          tabIndex={0}
          aria-label="backdrop"
          onClick={(e) => {
            swallowEvent(e);
            onDismiss?.();
          }}
          onKeyDown={swallowEvent}
        />
      }
    >
      {children}
    </BottomSheet>
  );
};
